module.exports = __webpack_public_path__ + "img/13.f4833d95.jpg";